export default "__VITE_ASSET__D9ohsJII__"